import { FieldProps } from '../../types';

export default ({ file, encoding, separator }: FieldProps) => {
  const errors: { file?: string; encoding?: string; separator?: string } = {};

  if (!file || file?.length === 0) {
    errors.file = 'Select file';
  }

  if (!encoding) {
    errors.encoding = 'Select encoding';
  }

  if (!separator) {
    errors.separator = 'Select separator';
  }

  return errors;
};
